var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSeatBlockedBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#CCCCCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "white",
    strokeOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6928 19.1018C21.0152 19.4242 21.1765 19.5855 21.381 19.6351C21.5463 19.6753 21.7618 19.6479 21.9118 19.5676C22.0973 19.4684 22.2002 19.2939 22.4058 18.9448C24.6081 15.2071 24.1043 10.3157 20.8943 7.10571C17.6843 3.89573 12.793 3.3919 9.05517 5.59422C8.70615 5.79986 8.53164 5.90268 8.43237 6.08825C8.35212 6.23826 8.32472 6.45372 8.36488 6.61905C8.41455 6.82355 8.57577 6.98477 8.89821 7.30721L20.6928 19.1018ZM18.9449 22.4058C19.2939 22.2001 19.4684 22.0973 19.5677 21.9118C19.6479 21.7617 19.6753 21.5463 19.6351 21.381C19.5855 21.1765 19.4243 21.0152 19.1018 20.6928L7.30722 8.8982C6.98478 8.57576 6.82356 8.41454 6.61906 8.36487C6.45373 8.32471 6.23827 8.35211 6.08826 8.43236C5.90269 8.53163 5.79987 8.70614 5.59423 9.05516C3.39191 12.7929 3.89574 17.6843 7.10572 20.8943C10.3157 24.1043 15.2071 24.6081 18.9449 22.4058ZM22.4853 5.51472C27.1716 10.201 27.1716 17.799 22.4853 22.4853C17.799 27.1716 10.201 27.1716 5.51473 22.4853C0.82844 17.799 0.82844 10.201 5.51473 5.51472C10.201 0.828428 17.799 0.828428 22.4853 5.51472Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSeatBlockedBook);
export default __webpack_public_path__ + "static/media/default-seat-blocked-book.68a1d058ee28cace4ab7713dae01c91e.svg";
export { ForwardRef as ReactComponent };